export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAADwAQMAAAAQIid1AAAAA1BMVEXn6eldvemGAAAADUlEQVQYGWMYBcMaAAAB4AAB20ScTQAAAABJRU5ErkJggg=="